import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  login: function(user) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/clients/web/admin/login", {
      email: user.email,
      password: user.password
    });
  },
  logout: function() {
    return axios.delete(IMPROVE_CONFIG.API_URL + "/logout");
  },
  register: function(user) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/register", {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      password: user.password,
      confirm_password: user.confirm_password,
      company_name: user.company_name,
      banding: user.banding,
      product: user.product,
      newsletter: user.newsletter,
      refid: user.refid,
      // "website" when the signup came from the marketing site's trial
      // button; the API turns it into companies.is_referred.
      refer: user.refer
    });
  },
  getHubspot: function() {
    return axios.post(IMPROVE_CONFIG.API_URL + "/hub-spot", {
      email: "dave@dave.com"
    });
  },
  forgotPassword: function(email, resetUrl) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/password/forgot", {
      email: email,
      reseturl: resetUrl
    });
  },
  resetPassword: function(email, newPassword, token, isResetPassword) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/password/reset", {
      email: email,
      password: newPassword,
      token: token,
      isResetPassword: isResetPassword
    });
  },
  refreshToken: function() {
    return axios.post(IMPROVE_CONFIG.API_URL + "/groups/");
  },
  autologin: function(user) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/clients/web/admin/autologin", {
      //email: user.email,
      //password: user.password
      id:user.id
    });
  },
  checkResetPasswordToken: function(email, token) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/validate-token/" + token, {
      email: email
    });
  },
  authenticateSSO: function (data) {
    return axios.post(IMPROVE_CONFIG.SSO_URL +'/authenticate', data);
  },
};
